import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungWuerzburg() {
  return (
    <CityPageTemplate
      city="Würzburg"
      slug="wuerzburg"
      intro="Würzburg als fränkische Weinstadt – Deine Finanzen sollten genauso gut reifen wie ein guter Frankenwein."
      description="Unabhängige & digitale Finanzberatung für Würzburg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
